import { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import * as R from 'ramda';
import AccountModal from '../Components/AccountModal';

const AccountTable = ({}) => {
  const [contacts, setContact] = useState([]);
  const [form, setForm] = useState(null);
  const getContacts = () => {
    axios.get('/api/v1/accounts').then(({ data }) => {
      if (data.success) {
        setContact(data.payload.accounts);
      }
    });
  };
  useEffect(() => {
    getContacts();
  }, []);

  const handleDelete = (account) => {
    if (
      window.confirm(
        `Do you want to remove account ${account.name} - ${account.phone_number} ?`
      ) == true
    ) {
      axios.delete(`/api/v1/accounts/${account.id}`).then(({ data }) => {
        if (data.success) {
          setContact(R.filter((item) => item.id !== account.id, contacts));
        }
      });
    }
  };
  const handleSave = (account) => {
    if (!form?.id) {
      setContact([...contacts, account]);
    } else {
      const idx = R.findIndex((item) => item.id === form?.id, contacts);
      if (idx >= 0) {
        const updated = [...contacts];
        updated[idx] = account;
        setContact(updated);
      } else {
        setContact([...contacts, account]);
      }
    }
  };

  const openEditModal = (e, account) => {
    e.preventDefault();
    setForm(account);
  };
  const openModal = (e) => {
    e.preventDefault();
    setForm({ email: '', name: '', company: '', phone_number: '' });
  };
  const closeModal = (e) => {
    e.preventDefault();
    setForm(null);
  };
  return (
    <>
      <section id='accounts' style={{ marginTop: 100 }}>
        <div class='border-2 border-[#f4f4f4] rounded-md mt-16 my-10'>
          <div class='p-[26px] border-b-2 border-[#f4f4f4]'>
            <a
              class='btn btn-sm btn-custom navbar-btn btn-rounded'
              href='#'
              onClick={openModal}
            >
              Add account
            </a>
          </div>
          <div class='p-[26px]'>
            <p class='text-lg font-semibold'>Accounts</p>
            <div class='overflow-x-auto w-full mt-4'>
              <table class='w-full m-0 border whitespace-nowrap border-[#dee2e6]'>
                <thead>
                  <tr class='text-left'>
                    <th class='p-3 border border-[#dee2e6]'>Phone number</th>
                    <th class='p-3 border border-[#dee2e6]'>Display name</th>
                    <th class='p-3 border border-[#dee2e6]'>Email</th>
                    <th class='p-3 border border-[#dee2e6]'>Company</th>
                    <th class='p-3 border border-[#dee2e6]'>Updated at</th>
                    <th class='p-3 border border-[#dee2e6]'></th>
                  </tr>
                </thead>
                <tbody>
                  {contacts.map((item) => (
                    <tr key={item.id}>
                      <td class='p-3 border border-[#dee2e6]'>
                        {item.personal === 0 && <b>*Admin&nbsp;&nbsp;</b>}
                        <code class='text-[#e83e8c]'>{item.phone_number}</code>
                      </td>
                      <td class='p-3 border border-[#dee2e6]'>{item.name}</td>
                      <td class='p-3 border border-[#dee2e6]'>{item.email}</td>
                      <td class='p-3 border border-[#dee2e6]'>
                        {item.company}
                      </td>
                      <td class='p-3 border border-[#dee2e6]'>
                        {moment(item.updated_at).format('DD/MM/YYYY')}
                      </td>
                      <td class='p-3 border border-[#dee2e6]'>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            rowGap: 5,
                          }}
                        >
                          <button
                            type='button'
                            class='btn-custom py-1'
                            onClick={(e) => openEditModal(e, item)}
                          >
                            Edit
                          </button>
                          {item.personal !== 0 && (
                            <button
                              type='button'
                              class='btn-custom py-1'
                              style={{ backgroundColor: 'red' }}
                              onClick={() => handleDelete(item)}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <AccountModal
        account={form}
        handleClose={closeModal}
        handleSave={handleSave}
      />
    </>
  );
};
export default AccountTable;
